module.exports = __webpack_public_path__ + "assets/search-icon.ae0372a5.svg";